import { render, staticRenderFns } from "./SystemSettingEditor.vue?vue&type=template&id=540fd4ca&"
import script from "./SystemSettingEditor.vue?vue&type=script&lang=js&"
export * from "./SystemSettingEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports